import {
  FC,
  ButtonHTMLAttributes,
  memo,
  ReactNode,
  useState,
  MouseEvent,
} from 'react';
import styled from 'styled-components';

const StyledButton = styled.button<{ $isPressed: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  opacity: ${({ $isPressed }) => ($isPressed ? 0.7 : 1)};
  transition: opacity 0.2s ease;
  padding: 0;
  margin: 0;

  &:disabled {
    cursor: default;
  }
`;

type Props = {
  children: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const TouchableOpacity: FC<Props> = ({
  children,
  onClick,
  disabled = false,
  onMouseDown,
  onMouseUp,
  onMouseLeave,
  ...props
}) => {
  const [isPressed, setIsPressed] = useState<boolean>(false);

  const handleMouseDown = (e: MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      setIsPressed(true);
    }
    onMouseDown?.(e);
  };

  const handleMouseUp = (e: MouseEvent<HTMLButtonElement>) => {
    if (!disabled) {
      setIsPressed(false);
      e.stopPropagation();
      onClick?.(e);
    }
    onMouseUp?.(e);
  };

  const handleMouseLeave = (e: MouseEvent<HTMLButtonElement>) => {
    if (isPressed) {
      setIsPressed(false);
    }
    onMouseLeave?.(e);
  };

  return (
    <StyledButton
      disabled={disabled}
      $isPressed={isPressed}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default memo(TouchableOpacity);
